import mitt from 'mitt'
import { Cut } from '../types'
import { Either } from 'fp-ts/lib/Either'
import {
  DialogEventHandlerArgError,
  DialogEventHandlerArgSuccess,
} from '../types/dialog'

export type Events = {
  PROCESS_BINDING_ON_DATA_CHANGE: string
  OnExcelWorkbooksSelectionChange: string
  ON_REFERENCE_SELECTED: string
  BINDING_ON_DATA_CHANGE: string
  DELETE_ALL_REFERENCES: null
  UNDO: null
  REDO: null
  OPEN_DIALOG: null
  OPEN_USER_SETTINGS: null
  Navigation: string
  ReferenceDeletion: {
    sheetId: string
    rangeAddress: string
  }
  SHOW_DUPLICATE_FINDINGS_POP_UP: string
  CutType: Cut
  OfficeDialiogEvent: Either<
    DialogEventHandlerArgError,
    DialogEventHandlerArgSuccess
  >
}

const mittEmitter = mitt<Events>()

export default mittEmitter
